
app = {
	//app.dispatcher.dispatch(EVENTS.MODAL_VIDEO_CLOSE)
	dispatcher :  new Dispatcher(),
	isFBbrowser : false,
	pageHeights : null,

	init : function(){
		Utils.initOauth( );

		//PAGE CONTROLLER DEALS WITH PAGE SWAPS CHECKING USER CAN GO TO THE NEXT SCREEN AND CONTROLLING WHERE HE IS AT
		//UPLOAD VIEW DEALS WITH LOADING AND DISPLAYING IMAGE BY WEBCAM OR FILEBROWSED,IT RESCALES THE IMAGE AND CHECKS EXIF DATA
		//IMAGE EDIT VIEW PIXI CANVAS THAT DEALS WITH RESCALING/POSITIONING/ADJUSTING BRIGHTNESS/CONTRAST AND CREATING THE FINAL POSTER TO BE SHARED
		app.tracking = new Tracking( app.dispatcher );
		app.pageController = new PageController( app.dispatcher );
		app.uploadView = new UpladWebCamView( app.dispatcher );	
		app.imageView = new ImageEditView( app.dispatcher );	
		app.animationView = new AnimationsView( app.dispatcher );
		app.bindEvents();

		if(Detectizr.device.type != "desktop"){
			app.pageHeights = Utils.getPageHeights();
			if(app.pageHeights != null) app.rescalePage();
		}else{
			app.pageHeights = Utils.getPageHeights();
			app.pageHeights.body = $(dom.landing.container).height()
			app.animationView.introPreloader();
		}
			
			
// 		$(".content__img img").width($(".content__img img").height()* 0.78245614);
	
			
	},
	
	bindEvents : function(){
		window.addEventListener("orientationchange" , app.onOrientationChange );
	},
	
	blurEvents: function() {
		
	},
	
	rescalePage : function(){
		$(".page").height( app.pageHeights.body );
		$(".content__img img").width($(".content__img img").height()* 0.78245614)
		app.dispatcher.dispatch( EVENTS.RESIZE );
		app.animationView.introPreloader();
	},

	rescalePages : function(){
		app.rescaleShare();
		app.rescaleLanding();
	},
	
	rescalePreloader:function() {
		var bm = Utils.getBodyHeight( false );
		$(dom.preloader.container).height( bm );

		$(".preloader").height( bm );
	},

	rescaleLanding : function() {
	
		if (  (window.orientation === 0) || (window.orientation === 180) ){
			
			var bm = Utils.getBodyHeight( true );
			$(dom.landing.container).height( bm );
		
			$(".page").height( bm );
		}

	},

	rescaleShare : function(){
		if( (screen.width<=320) && (Detectizr.browser.name === "safari") ){
			$(dom.sharePage.container).height(app.pageHeights.share *0.945 );
		
		}else{
			$(dom.sharePage.title).css("display","block");
			$(dom.sharePage.body).css("margin-top","10px");
			$(dom.sharePage.container).height( app.pageHeights.share );
		
			var imgWidth = $(dom.sharePage.body).height() * ( 540 / 690 );
			var titleHeight = $(dom.sharePage.title).height();
		
			var navWidth = $(dom.sharePage.nav).width() + parseInt( $(dom.sharePage.nav).css("margin-right") );
			var sharePageRealWidth = imgWidth + navWidth;
			var pageWidth = app.pageHeights.bodyW;
		
			if( sharePageRealWidth > pageWidth ){
				var imgNewHeight = (pageWidth - navWidth) * ( 690 / 540 );
				imgNewHeight += $(dom.sharePage.title).height() + parseInt( $(dom.sharePage.body).css("margin-top") );
				$(dom.sharePage.container).height( imgNewHeight );
			}
		}
	},

	/*---------------------------------------------------
		EVENT HANDLERS 
	--------------------------------------------------*/
	onOrientationChange : function( event ){
		setTimeout(function(){
			if(app.pageHeights == null){
				app.pageHeights = Utils.getPageHeights();
				 if(app.pageHeights != null) app.rescalePage();
			}
		}, 200);
		
		app.checkOrientation(event);
	},
	
	checkOrientation : function( event ){
		if(window.orientation == undefined) return;
		
		if ( (window.orientation === 0) || (window.orientation === 180) ){
			document.getElementById("js-orientationLock").className = "orientationLock";
		}else{
			document.getElementById("js-orientationLock").className = "orientationLock is-shown";
		}
	},

	onStageResize : function( event ){
		if(Detectizr.device.type != "desktop"){
			app.dispatcher.dispatch( EVENTS.RESIZE );
		}

	}
	
	
	/*--------------------------------------------------*/
};

if (window.canLoad) {

	window.onload = app.init;

}
app.checkOrientation();
/*---------------------------------------------------
	SCOPE FUNCTION
--------------------------------------------------*/

	Function.prototype.bindX = function(scope) {
		var _function = this;
	
		return function() {
			return _function.apply(scope, arguments);
		};
	
	};	

window.onblur = function() {
	app.blurEvents();
};
/*---------------------------------------------------*/